import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import highlight from 'flarum/common/helpers/highlight';
import tagsLabel from 'ext:flarum/tags/common/helpers/tagsLabel';
import ItemList from 'flarum/common/utils/ItemList';
export default class SolutionSearchItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "query", void 0);
    _defineProperty(this, "discussion", void 0);
    _defineProperty(this, "bestAnswerPost", void 0);
    _defineProperty(this, "mostRelevantPost", void 0);
    _defineProperty(this, "tags", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.query = this.attrs.query;
    this.discussion = this.attrs.discussion;
    this.bestAnswerPost = this.attrs.bestAnswerPost;
    this.mostRelevantPost = this.attrs.mostRelevantPost;
    this.tags = this.attrs.tags;
  }
  view() {
    return m("li", {
      className: "SolutionSearchResult DiscussionSearchResult",
      "data-index": 'discussions' + this.discussion.id()
    }, m(Link, {
      href: app.route.discussion(this.discussion, this.bestAnswerPost && this.bestAnswerPost.number() || 0)
    }, this.viewItems().toArray()));
  }
  discussionTitle() {
    return this.discussion.title();
  }
  bestAnswerContent() {
    var _this$bestAnswerPost;
    return (_this$bestAnswerPost = this.bestAnswerPost) == null ? void 0 : _this$bestAnswerPost.contentPlain();
  }
  mostRelevantContent() {
    var _this$mostRelevantPos;
    return (_this$mostRelevantPos = this.mostRelevantPost) == null ? void 0 : _this$mostRelevantPos.contentPlain();
  }
  viewItems() {
    var _this$mostRelevantCon, _this$bestAnswerConte;
    const items = new ItemList();
    app.forum.attribute('showTagsInSearchResults') && items.add('tags', m("div", {
      className: "SolutionSearchResult-tags"
    }, tagsLabel(this.tags)), 100);
    items.add('discussion-title', m("div", {
      className: "DiscussionSearchResult-title"
    }, highlight(this.discussionTitle(), this.query)), 90);
    !!this.mostRelevantPost && items.add('most-relevant', m("div", {
      className: "DiscussionSearchResult-excerpt"
    }, highlight((_this$mostRelevantCon = this.mostRelevantContent()) != null ? _this$mostRelevantCon : '', this.query, 100)), 80);
    !!this.bestAnswerPost && items.add('best-answer', m("div", {
      className: "DiscussionSearchResult-excerpt SolutionSearchResult-bestAnswer"
    }, highlight((_this$bestAnswerConte = this.bestAnswerContent()) != null ? _this$bestAnswerConte : '', this.query, 100)), 70);
    return items;
  }
}
flarum.reg.add('fof-best-answer', 'forum/components/SolutionSearchItem', SolutionSearchItem);